import { useSelector } from 'react-redux';

import {
  hasSignedRequiredDocuments,
  isAuthenticated,
  hasAnyPermission,
} from '@f/services/authentication/authentication.selectors';

export default function ({ allowedPermissions, children }) {
  const isUserAuthenticated = useSelector(state => isAuthenticated(state));
  const hasUserSignedRequiredDocuments = useSelector(state => hasSignedRequiredDocuments(state));
  const hasUserAccess = useSelector(state => hasAnyPermission(state, allowedPermissions));

  if (!isUserAuthenticated || !hasUserSignedRequiredDocuments || !hasUserAccess) {
    return null;
  }

  return children;
}
